import { ref, reactive } from 'vue';

// types
import { Props, CurrentOrder, IBar } from '../../../types';

// chart interface
import type { IChartingLibraryWidget } from 'charting_library';

// Переменная для хранения единственного экземпляра
let globalsInstance: ReturnType<typeof createGlobals> | null = null;

// Функция для создания глобального состояния
function createGlobals(props: Props) {
    const init = ref(false);
    const widget = ref<IChartingLibraryWidget | undefined>();
    const chartContainer = ref<HTMLElement | null>(null);
    const historyOrdersQueue = ref<CurrentOrder[]>([]);
    const widgetOrders = reactive<{ [key: string]: any }>({});
    const priceOffsets = reactive<{ [key: string]: any }>({});
    const timeFrame = ref<string>('15');
    const orderBackgrounds = {
        'dark': '#202020',
        'light': '#FFFFFF',
    };
    const interval = ref();
    const barsGl = reactive<{ [key: string]: IBar[] }>({});
    const processing = reactive<{ [key: string]: boolean }>({
        renderOrders: false,
    });

    return {
        init,
        widget,
        timeFrame,
        chartContainer,
        historyOrdersQueue,
        widgetOrders,
        priceOffsets,
        orderBackgrounds,
        processing,
        barsGl,
        interval,
    };
}

// Функция useGlobals, возвращающая один и тот же объект во всех вызовах
export function useGlobals(props: Props) {
    if (!globalsInstance) {
        globalsInstance = createGlobals(props);
    }
    return globalsInstance;
}
